import { z } from 'zod';

export const FileUploadSchema = z.object({
	name: z.string(),
	data: z.string(),
	uuid: z.string().optional(),
	size: z.number(),
	type: z.string(),
	extension: z.string(),
});

export const FileSchema = FileUploadSchema.extend({
	data: z.string().optional(),
});

export type FileType = z.infer<typeof FileSchema>;
export type FileUpload = z.infer<typeof FileUploadSchema>;

export const defaultPieceColors = [
	{ color: 'red' },
	{ color: 'green' },
	{ color: 'blue' },
	{ color: 'yellow' },
	{ color: 'orange' },
	{ color: 'white' },
	{ color: 'cyan' },
	{ color: 'brown' },
	{ color: 'gray' },
	{ color: 'black' },
	{ color: 'pink' },
	{ color: 'purple' },
];
